import { Product } from "@resamare/models";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../config";

type GetProductsParams = {
    productTypeId?: number | number[];
};

async function getProducts(params?: GetProductsParams): Promise<Product[]> {
    const response = await apiClient.get(`/produits`, {
        params: {
            produit_type_id: Array.isArray(params?.productTypeId)
                ? params.productTypeId.join(",")
                : params?.productTypeId,
        },
    });

    return response.data;
}

export function useGetProducts(params?: GetProductsParams) {
    const query = useQuery({
        queryKey: ["products", params],
        queryFn: () => getProducts(params),
    });

    return query;
}
